<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <transition>
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>
<script setup lang="ts">
import { onMounted } from "vue";
import windowFn from "@/utils/windowFn";

onMounted(() => {
  windowFn();
});
</script>

<style lang="scss" scoped></style>
<style>
</style>
